import { useEffect, useMemo } from 'react';
import { RoutePath } from '..';
import ShareIcon from '../../assets/icons/ShareIcon';
import CustomQRCode from '../../components/CustomQRCode';
import Button from '../../components/button';
import CopyToClipboard from '../../components/copyToClipboard';
import { FlexCenter, PageContent } from '../../components/modal/styles';
import { useContext } from '../../context';
import { useAccount } from '../../hooks/useAccount';
import useIsMobile from '../../hooks/useIsMobile';
import useLocales from '../../hooks/useLocales';
import { useRouter } from '../../hooks/useRouter';
import { useWalletConnectUri } from '../../hooks/useWalletConnectUri';
import { type WalletProps } from '../../hooks/useWalletsProps';
import { Actions, Description, Wrapper } from './styles';

const Page = ({ wallet }: { wallet: WalletProps }) => {
  const { navigate } = useRouter();
  const locales = useLocales();
  const mobile = useIsMobile();
  const { uri: walletConnectUri = '', requestUri, error } = useWalletConnectUri(wallet?.connector?.id);
  const { config } = useContext();
  const { isConnected } = useAccount();

  useEffect(() => {
    requestUri();
  }, []);

  useEffect(() => {
    return () => {
      // connect status  -> connected / disconnected
      if (!isConnected) {
        config.setState((x) => ({
          ...x,
          // Keep existing connector connected in case of error
          status: x.current ? 'connected' : 'disconnected',
        }));
      }
    };
  }, [isConnected]);

  const visiableWalletButton = useMemo(() => {
    if (mobile || wallet?.id === 'walletConnect') {
      return false;
    } else {
      return true;
    }
  }, [wallet, mobile]);

  return (
    <PageContent style={{ marginTop: 0 }}>
      <Wrapper>
        <CustomQRCode
          value={
            walletConnectUri && wallet.getWalletConnectDeeplink
              ? wallet.getWalletConnectDeeplink(walletConnectUri)
              : walletConnectUri
          }
          failed={!!error}
          failedCallback={() => {
            requestUri();
          }}
          image={wallet?.icon}
        />
        {!!walletConnectUri && (
          <Actions>
            <CopyToClipboard variant='button' string={walletConnectUri}>
              {locales.copyQRURI}
            </CopyToClipboard>

            {visiableWalletButton && (
              <Button
                style={{
                  background: 'none',
                  borderColor: 'var(--pcm-button-border-color)',
                }}
                onClick={() => {
                  navigate(RoutePath.DownloadApp, { wallet });
                }}
              >
                <FlexCenter
                  gap={8}
                  style={{
                    color: 'var(--pcm-body-color-secondary)',
                  }}
                >
                  <ShareIcon />
                  {locales.getWallet}
                </FlexCenter>
              </Button>
            )}
          </Actions>
        )}

        <Description>{locales.scanQRCode}</Description>
      </Wrapper>
    </PageContent>
  );
};

export default Page;
